/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5.5289 1c0-.5523.4457-1 .9956-1h10.951c.5499 0 .9956.4477.9956 1s-.4457 1-.9956 1h-1.9911v6.1174l6.7344 7.5449C25.0926 18.882 22.8176 24 18.5125 24H5.4875c-4.305 0-6.5801-5.118-3.7063-8.3377l2.7522-3.0834V12.5h.0704l3.9118-4.3826V2H6.5245c-.5499 0-.9956-.4477-.9956-1Zm4.9778 1v6.8826L5.5 14.5h13l-5.0067-5.6174V2h-2.9866Z"
    clipRule="evenodd"
  />,
  'MenuTestFilled'
);
